// extracted by mini-css-extract-plugin
export default {"dashboard":"AllTasks_dashboard__m1K5c"};